<div id="menu-nav" class="visible-lg-inline-block menu-nav" role="navigation">
  <ul class="navtabs flex-auto" aria-label="primary" id="navtabs">
    <li class="top-nav-item" [ngClass]="{active: primaryNavItem.isActive === 'true'}" *ngFor="let primaryNavItem of primaryNavs; index as PNavIndex;">

      <a [href]="primaryNavItem.url" [attr.data-qa]="'gn-primary-nav-'+PNavIndex" [class.no-primary]="primaryNavItem.title === ''"
       [attr.aria-current]="(primaryNavItem.isActive === 'true' && (!primaryNavItem.children || primaryNavItem.children.length === 0 )) ? 'page' : null"
        >{{primaryNavItem.title}}</a>
      <gn-secondary-nav data-qa="gn-secondary-navs" [secondaryNav]="primaryNavItem.children" *ngIf="primaryNavItem.isActive === 'true' && primaryNavItem.children && primaryNavItem.children.length > 0"></gn-secondary-nav>
    </li>
  </ul>
</div>
